const GREEK_MONEY_FORMATTER = new Intl.NumberFormat("el-GR", {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function roundToCents(value: number): number {
  return Math.round(value * 100) / 100;
}

function hasOnlyThousandsDotGroups(value: string): boolean {
  const groups = value.split(".");
  return groups.length > 1 && groups.slice(1).every((group) => group.length === 3);
}

export function sanitizeGreekMoneyDraft(value: string): string {
  return Array.from(value)
    .filter((char) => /[\d.,\s]/.test(char))
    .join("")
    .replace(/^\s+/, "");
}

export function parseGreekMoneyInput(value: string): number | null {
  const draft = sanitizeGreekMoneyDraft(value).replace(/\s+/g, "");

  if (!draft || !/\d/.test(draft)) {
    return null;
  }

  const hasComma = draft.includes(",");
  const hasDot = draft.includes(".");
  let normalized = draft;

  if (hasComma) {
    normalized = draft.replace(/\./g, "").replace(",", ".");
  } else if (hasDot && hasOnlyThousandsDotGroups(draft)) {
    normalized = draft.replace(/\./g, "");
  }

  const parsed = Number(normalized);

  if (!Number.isFinite(parsed)) {
    return null;
  }

  return roundToCents(parsed);
}

export function formatGreekMoneyInput(value: number): string {
  return GREEK_MONEY_FORMATTER.format(roundToCents(value));
}
